import React, { Component, useState } from 'react'
//import { Button, Modal } from 'react-bootstrap'

import './Contacto.css'

import { Form } from './Form'


export class Contacto extends Component {

  openWin() {
    const url = 'https://wa.me/',
          newWin = (window.open(url, '', "width=500,height=300,left=200,resizable=yes,scrollbars=yes,status=yes"));
    if (newWin) newWin.focus();
  }

  render() {
    return (
      <div className="content" id="contact">
        <div className="container cl-descrip">
          <h3 className='texto-titulo'>CONTACTO</h3>

          <Form />

          <div className="cont-data">

            <div className="data-item" style={{ display: 'none' }}>
              <span>Celular</span><br/>
              <span className="desktop-tel"></span>

              <div className="celular">
                <button className="wapp" onClick={this.openWin}>
                  <i className="fab fa-whatsapp-square"></i>
                  <span className="mobile-tel"></span>
                </button>
              </div>
            </div>

           <div className="data-item p-0 mb-4">
              <p className="comment m-0 pb-0"><span role="img" aria-label="emoji" style={{ fontSize: '1.6rem' }}>📧</span> Email:
                <a className="mail" style={{ fontSize: '1rem' }} target='_blank' href="mailto:hola@tinchoenelbajo.com.ar?subject=Consulta%20Clases%20de%20Bajo" rel="noopener noreferrer">
                  <b> hola@tinchoenelbajo.com.ar</b>
                </a>
              </p>
              <p className="comment m-0 pt-0"><span role="img" aria-label="emoji" style={{ fontSize: '1.6rem' }}>💬</span> WhatsApp:
                <a className="mail" style={{ fontSize: '1rem' }} target='_blank' href="https://wa.me/541154771291?text=Hola Tincho! Me podrás pasar más info sobre las clases de bajo?" rel="noopener noreferrer">
                  <b> 549 11 5477 1291</b>
                </a>
              </p>
              {/* <span>E-mail</span><br/> */}
            </div>

            <div className="data-item dir"  style={{ display: 'none' }}>
              <span>Dirección</span><br/>
              <a href="/" target="_blank" rel="noopener noreferrer">
                , Tribunales, CABA<br/>
              </a>
              <a href="/" target="_blank" rel="noopener noreferrer">
                , Villa Devoto, CABA
              </a>
            </div>
          </div>

          {/* <EnviarMensaje /> */}

            <a className="mensaje btn" style={{fontSize: '2.4rem', color: '#3B49DB'}} href="https://wa.me/541154771291?text=Hola Tincho! Me podrás pasar más info sobre las clases de bajo?" target="_blank" rel="noopener noreferrer">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"></path>
              </svg>
            </a>


        </div>
      </div>
    )
  }
}


/* function EnviarMensaje() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="mensaje btn" onClick={handleShow}>
        <span className="material-icons" style={{fontSize: '2.4rem'}}>email</span>
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className='modal-fondo'>
          <Modal.Title className='texto-cursiva'>Escribime un mensaje!</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form />

        </Modal.Body>
      </Modal>
    </>
  );
} */
